import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-warning",
  "use": "icon-icon-warning-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-icon-warning\">\r\n  <defs>\r\n    <style>\r\n      #icon-icon-warning .cls-1 {\r\n        fill: #df5454;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"icon-icon-warning_路径_305\" data-name=\"路径 305\" class=\"cls-1\" d=\"M72,64a8,8,0,1,0,8,8A8,8,0,0,0,72,64Zm0,14.643A6.643,6.643,0,1,1,78.643,72,6.644,6.644,0,0,1,72,78.643Z\" transform=\"translate(-64 -64)\" />\r\n  <path id=\"icon-icon-warning_路径_306\" data-name=\"路径 306\" class=\"cls-1\" d=\"M464.854,640.854m-.854,0a.854.854,0,1,0,.854-.854A.854.854,0,0,0,464,640.854Z\" transform=\"translate(-456.854 -629.71)\" />\r\n  <path id=\"icon-icon-warning_路径_307\" data-name=\"路径 307\" class=\"cls-1\" d=\"M480.142,293.126H481a.143.143,0,0,0,.142-.142v-4.841A.143.143,0,0,0,481,288h-.854a.143.143,0,0,0-.142.142v4.841A.143.143,0,0,0,480.142,293.126Z\" transform=\"translate(-472.57 -283.994)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-warning.svg
// module id = SfAA
// module chunks = 3